import { motion } from "framer-motion";
import Lottie from "lottie-react";
import { useEffect, useState } from "react";
import styles from "./SubjectCard.module.scss";

const bumperImageMap: Record<string, string> = {
  coins: "/illustrations/themes/Coin.svg",
  "speech-bubble": "/illustrations/themes/SpeechBubble.svg",
  heart: "/illustrations/themes/Heart.svg",
  emoji: "/illustrations/themes/Smiley.svg",
  supermarket: "/illustrations/themes/Cart.svg",
};

export default function SubjectCard({
  category,
  active,
  selected,
  inactive,
}: {
  category: CategoryEntity;
  active?: boolean;
  selected?: boolean;
  inactive?: boolean;
}) {
  const [tapEffect, setTapEffect] = useState(false);
  const [animationData, setAnimationData] = useState<string | null>(null);

  // Play tap effect on click
  useEffect(() => {
    setTapEffect(true);
    const timer = setTimeout(() => setTapEffect(false), 200);
    return () => clearTimeout(timer);
  }, [active]);

  // Load animation data
  useEffect(() => {
    if (category.image) {
      fetch(category.image)
        .then((res) => res.json())
        .then((data) => setAnimationData(data))
        .catch(() => setAnimationData(null));
    }
  }, [category.image]);

  const bumperImage = category.bumper
    ? bumperImageMap[category.bumper]
    : "/illustrations/themes/smiley.svg";

  return (
    <motion.div
      className={`${styles.card} ${selected ? styles.selected : ""} ${active ? styles.active : ""} ${category?.bumper ? styles[category.bumper] : ""}`}
      animate={{
        scale: tapEffect ? 0.9 : selected ? 1.15 : 1,
        opacity: inactive ? 0.35 : 1,
      }}
      transition={{ duration: 0.2 }}
    >
      {animationData && active && (
        <motion.div
          className={styles.animationWrapper}
          animate={{ opacity: active ? 0.25 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <Lottie
            className={styles.lottie}
            animationData={animationData}
            loop={false}
            autoPlay={true}
          />
        </motion.div>
      )}
      <img src={bumperImage} alt={category.name} />
      <p>{category.name}</p>
    </motion.div>
  );
}
